import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";
import { useSeo } from "@/lib/seo";
import ArticleCard from "@/components/ArticleCard";
import { CATEGORIES } from "@/data/constants";

export default function NewsList() {
  const [params, setParams] = useSearchParams();
  const category = params.get("category") || "";
  useSeo({
    title: category ? `${category} News` : "All News",
    description: category
      ? `The latest ${category.toLowerCase()} stories, updates, and reporting from Wolfdog News.`
      : "Breaking wolfdog news, legislation updates, rescue stories, and educational reporting from Wolfdog News.",
  });
  const [articles, setArticles] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    api
      .get("/articles", { params: { status: "published", ...(category ? { category } : {}), limit: 60 } })
      .then((r) => setArticles(r.data))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [category]);

  return (
    <div className="max-w-7xl mx-auto px-4 py-14">
      <p className="overline text-[#8B6D1F]">Newsroom</p>
      <h1 className="font-display text-4xl sm:text-5xl font-black tracking-tight text-[#0A192F] mt-1">
        {category || "All"} News
      </h1>

      <div className="flex flex-wrap gap-2 mt-8 mb-10">
        <button
          onClick={() => setParams({})}
          data-testid="filter-all"
          className={`overline px-4 py-2 border transition-colors ${
            !category ? "bg-[#0A192F] text-white border-[#0A192F]" : "border-[#0A192F]/20 text-[#0A192F] hover:border-[#D4AF37]"
          }`}
        >
          All
        </button>
        {CATEGORIES.map((c) => (
          <button
            key={c}
            onClick={() => setParams({ category: c })}
            data-testid={`filter-${c}`}
            className={`overline px-4 py-2 border transition-colors ${
              category === c ? "bg-[#0A192F] text-white border-[#0A192F]" : "border-[#0A192F]/20 text-[#0A192F] hover:border-[#D4AF37]"
            }`}
          >
            {c}
          </button>
        ))}
      </div>

      {loading ? (
        <p className="text-[#4A5568]">Loading...</p>
      ) : articles.length ? (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-7">
          {articles.map((a) => (
            <ArticleCard key={a.id} article={a} />
          ))}
        </div>
      ) : (
        <p className="text-[#4A5568]">No articles in this category yet.</p>
      )}
    </div>
  );
}
